import * as React from 'react';
import * as styles from './AddNewButton.css';
import { IAIcon } from '../../icon/Icon';
import { IATooltip } from '../../tooltip/Tooltip';
import "../../../styles/BasicIA.css";
import { IFontSlots } from '../../../interfaces/IFontSlots';

export interface IProps {
  icon?: string;
  title?: string;
  color?: string;
  description?: string;
  isMobile?: boolean;
  fontSlots?: IFontSlots;
  onClick?: () => void;
}

export interface IState {
}

export class AddNewButton extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    this.state = {
    };
  }

  public render(): JSX.Element {
    return (
      <div
        tabIndex={0}
        className="IA_OnFocusOutline_outer"
        onClick={() => this.props.onClick()}
        onKeyPress={(event) => {
          if (event.key === "Enter") {
            this.props.onClick();
          }
        }}
      >
        <div
          tabIndex={-1}
          className={[styles.IA_addNewButton, "IA_OnFocusOutline_inner"].join(" ")}
        >
          <div className={styles.IA_icon}>
            <IAIcon
              title={this.props.icon}
              size={18}
              color={this.props.color}
            />
          </div>
          <div
            className={styles.IA_title}
            style={{
              fontFamily: this.props.fontSlots?.heading?.fontFamily
            }}
          >
            {this.props.title}
          </div>
          {this.props.description &&
            <div style={{
              float: "right",
              marginRight: 20,
              marginTop: 16,
              fontFamily: this.props.fontSlots?.body?.fontFamily
            }}>
              <IATooltip
                content="Tooltip"
                type={this.props.isMobile ? "popup" : "bubble"}
                styles={{
                  width: 100,
                  textAlign: "left",
                  color: "#333333"
                }}
                componentContent={
                  <div>
                    {this.props.description}
                  </div>
                }
              >
                <IAIcon
                  title={"Info"}
                  size={18}
                  color={this.props.color}
                />
              </IATooltip>
            </div>
          }
        </div>
      </div>
    );
  }
}